module.exports = __webpack_public_path__ + "static/media/Project1_Fig1.f499fddf.png";